var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 8.99976V10.9996V11.9995C4.66667 12.5518 4.21895 12.9995 3.66667 12.9995H2C1.44772 12.9995 1 12.5518 1 11.9995V7.11727C1 6.85866 1.10019 6.6101 1.27953 6.42378L5.77356 1.75495C6.16919 1.34392 6.82796 1.34664 7.22019 1.76092L11.7262 6.52019C11.902 6.70591 12 6.95195 12 7.20771V8.71406",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 9.00078V12.0005C8.33398 12.5528 8.7817 13.0005 9.33398 13.0005H11.0007C11.5529 13.0005 12.0007 12.5528 12.0007 12.0005V11.0007V8.71509",
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 11.2844L8.33398 9.42745C8.33398 8.87517 7.88627 8.42745 7.33398 8.42745L5.66732 8.42745C5.11503 8.42745 4.66732 8.87517 4.66732 9.42745L4.66732 9.85594L4.66732 11.2844",
    stroke: "black",
    strokeWidth: 1.2
  })));
};
export default SvgHome;